import { render, staticRenderFns } from "./BastionHost.vue?vue&type=template&id=81f7f8aa&"
import script from "./BastionHost.vue?vue&type=script&lang=js&"
export * from "./BastionHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports